import script from "./OCaracteristicaValor.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCaracteristicaValor.vue?vue&type=script&lang=ts&setup=true"

import "./OCaracteristicaValor.vue?vue&type=style&index=0&id=59fd2206&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fd2206"]])

export default __exports__